import React from 'react';
import Modal from '@medflex/components/stories/Modal';
import PermanentLink from '@medflex/components/stories/PermanentLink';
import { TRACKING_ACTIONS, trackEvent } from '@medflex/utils/Tracking';
import { showSuccessToast } from '@medflex/components/stories/Toast';
import { useTranslation } from 'react-i18next';
import useUserProfile from '../hooks/useUserProfile';
import useModal from '../hooks/useModal';

const PatientPermanentLinkModule = () => {
  const { open, close } = useModal();
  const { userProfile } = useUserProfile();
  const { t } = useTranslation('physician');

  const handleClose = () => {
    trackEvent({
      zone: 'patientPermanentLink',
      actionText: TRACKING_ACTIONS.CLOSE,
    });
    close({ modal: 'patientPermanentLink' });
  };

  const handleCopied = event => {
    trackEvent(event, {
      zone: 'InvitePatientModalModule',
      elementType: 'form',
      actionText: 'Invite Contact by copied permanentLink',
    });
    showSuccessToast(t('physician:toasts.permanent_link.copied'), null, {
      toastId: 'permanentLinkCopySuccess',
    });
  };

  return (
    <Modal
      showCloseButton
      onClickCloseButton={handleClose}
      title={t('messenger:PatientPermanentLinkModule.title')}
      infoUrl="https://medflex.de/hilfe/behandler-kontakte/patienten-einladen/"
    >
      <PermanentLink
        uri={userProfile.attributes.permanentInvitationPatientLink}
        onCopied={handleCopied}
        onClickGenerateNew={() => open({ modal: 'newPermanentLink', type: 'patient' })}
      >
        {t('messenger:PatientPermanentLinkModule.patient')}
      </PermanentLink>
    </Modal>
  );
};

export default PatientPermanentLinkModule;
